import { Link } from "react-router-dom";
import type { Actor } from "@/types/content";

export default function ActorCard({ actor }: { actor: Actor }) {
  return (
    <Link
      to={`/actors/${actor.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={actor.photo}
          alt={`${actor.name}照片`}
          title={`${actor.name} - 演员资料`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="font-heading text-base font-bold text-background-50">{actor.name}</h3>
          <p className="text-xs text-background-50/80">{actor.role}</p>
        </div>
      </div>
      <div className="p-3.5">
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{actor.bio}</p>
        <span className="inline-flex items-center gap-1 text-xs text-primary-600 mt-3 font-medium">
          查看资料
          <i className="ri-arrow-right-line" />
        </span>
      </div>
    </Link>
  );
}